import React from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { LanguageSelector } from '../components/LanguageSelector';
import { CustomButtonLegends } from 'handimap-react-lib/components/Button/CustomButton';
import { useResponsive } from 'handimap-react-lib/hooks/useResponsive';
import { showLegends } from 'handimap-react-lib/store/actions/legendActions';
import { openDataModal } from 'handimap-react-lib/store/actions/modalActions';

export const HeaderLegends = () => {
  const {t} = useTranslation();
  const { isMobile } = useResponsive();

  const dispatch = useDispatch();
  const { show } = useSelector(state => state.legendList);

  const handleShowLegend = () => {
    dispatch(showLegends(!show));
  };

  const handleShowHelper = () => {
    dispatch(openDataModal());
  };

  const styles = {
    container : {
      display: 'flex',
      backgroundColor: '#000000',
      justifyContent: isMobile ? 'center' : 'flex-end',
      paddingX: isMobile ? 0 : '2em'
    },
    rowContainer: {
      alignItems: 'center'
    }
  };
  return (
    <Box sx={styles.container}>
      <Stack sx={styles.rowContainer} direction='row' spacing={2}>
        <CustomButtonLegends 
          size='small' 
          startIcon={
            <FontAwesomeIcon icon={faInfoCircle} color='#FFFFFF'/>
          }
          onClick={handleShowLegend}
        >
          {show ? t('legend.close') : t('legend.open')}
        </CustomButtonLegends>
        <CustomButtonLegends 
          size='small' 
          startIcon={
            <FontAwesomeIcon icon={faQuestionCircle} color='#FFFFFF'/>
          }
          onClick={handleShowHelper}
        >
          {t('common.help_header')}
        </CustomButtonLegends>
        <LanguageSelector />
      </Stack>
    </Box>
  );
};